/* libs/oyan-ui/src/lib/features/sites/containers/site-overview/site-overview.component.scss */
.site-overview {
  box-sizing: border-box;
}
.invisible {
  display: none;
}
.visible {
  display: block;
  animation: fadein 1s cubic-bezier(0.4, 0.2, 0.59, 0.92);
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*# sourceMappingURL=site-overview.component.css.map */
